export const CONFIG = {
  G: 1.0,
  EPSILON: 0.05,
  FIXED_DT: 1 / 120,
  MAX_SUBSTEPS: 64,
  SOFT_RADIUS: 14,
  SOFT_K: 0.02,
  DAMPING_GAMMA: 2e-4,
  ESCAPE_RADIUS: 40,
  ESCAPE_GRACE_SEC: 8,
  OFFSCREEN_GRACE_SEC: 5,
  VIEW_MARGIN: 1.18,
  PLANET_MASS: 1e-4,
  T_YEAR: 2.0,
  T0: 300,
  D_REF: 2.0,
  D_FLOOR: 0.35,
  T_MIN: 20,
  T_MAX: 4000,
  TRAIL_LENGTH: 180,
  TRAIL_SAMPLE_DT: 0.035,
  // cinematic defaults — keep cores readable, soft corona only
  BLOOM_STRENGTH: 0.42,
  BLOOM_RADIUS: 0.28,
  BLOOM_THRESHOLD: 0.55,
  FADE_SEC: 0.4,
  POV_TRANSITION_SEC: 1.2,
  POV_EYE_HEIGHT: 0.32,
  POV_FOV: 88,
  /** Max auto-aim slew (rad/s) so close flybys do not whip the camera. */
  POV_AIM_SLEW_RAD_S: 0.7,
  /** Max surface-up slew (rad/s) — day-side footing follows stars smoothly. */
  POV_UP_SLEW_RAD_S: 0.4,
  /** Min on-screen angular radius for star cores while in POV. */
  POV_STAR_MIN_ANG: 0.04,
  SCORCHING_T: 450,
  FREEZING_T: 280,
};
